import { render, staticRenderFns } from "./arrears-overview.vue?vue&type=template&id=88edf822"
import script from "./arrears-overview.vue?vue&type=script&lang=js"
export * from "./arrears-overview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports